import React, { useEffect, useMemo, useState } from "react";
import "./LoginScreen.css";

const CANONICAL_ORIGIN = "https://waffarhanexus.online";
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://gufmotkoeoqvmxjeqbmw.supabase.co";
const ALLOWED_TYPES = new Set(["email", "recovery", "invite", "email_change", "magiclink"]);

function safeParams() {
  const params = new URLSearchParams(window.location.search);
  const tokenHash = params.get("token_hash") || "";
  const type = params.get("type") || "";
  const redirectTo = params.get("redirect_to") || "";
  const tokenLooksSafe = /^[A-Za-z0-9._~-]{8,512}$/.test(tokenHash);
  return { tokenHash: tokenLooksSafe ? tokenHash : "", type: ALLOWED_TYPES.has(type) ? type : "", validRedirect: redirectTo === `${CANONICAL_ORIGIN}/` || redirectTo === CANONICAL_ORIGIN };
}

function copyFor(type) {
  if (type === "recovery") return { title: "Reset your password", body: "Continue securely to choose a new password." };
  if (type === "invite") return { title: "Accept your invitation", body: "Continue securely to activate your Nexus access." };
  if (type === "email_change") return { title: "Confirm your new email", body: "Continue securely to confirm this email address." };
  if (type === "magiclink") return { title: "Sign in to Nexus", body: "Continue securely to sign in to Waffarha Nexus." };
  return { title: "Verify your email", body: "You’re confirming access to Waffarha Nexus." };
}

export default function AuthContinuation() {
  const [params] = useState(safeParams);
  const [state, setState] = useState(() => params.tokenHash && params.type && params.validRedirect ? "ready" : "invalid");
  const copy = useMemo(() => copyFor(params.type), [params.type]);

  useEffect(() => {
    document.title = `${copy.title} | Waffarha Nexus`;
    const previous = document.querySelector('meta[name="referrer"]');
    const meta = previous || document.createElement("meta");
    const previousContent = meta.getAttribute("content");
    meta.setAttribute("name", "referrer");
    meta.setAttribute("content", "no-referrer");
    if (!previous) document.head.appendChild(meta);
    window.history.replaceState({}, document.title, "/auth/continue");
    return () => { if (previous) previous.setAttribute("content", previousContent || ""); else meta.remove(); };
  }, [copy.title]);

  function continueAction() {
    if (state !== "ready") return;
    setState("loading");
    const verifyUrl = new URL(`${SUPABASE_URL}/auth/v1/verify`);
    verifyUrl.searchParams.set("token", params.tokenHash);
    verifyUrl.searchParams.set("type", params.type);
    verifyUrl.searchParams.set("redirect_to", `${CANONICAL_ORIGIN}/`);
    window.location.assign(verifyUrl.toString());
  }

  const statusCopy = { invalid: { title: "This link is not valid", body: "Request a new email from the Nexus sign-in page." }, ready: copy, loading: { title: "Continuing securely", body: "This may take a moment." } }[state];
  return <div className="login-container nexus-auth-shell nexus-continuation-shell"><main className="nexus-auth-panel" data-testid="auth-continuation"><div className="nexus-auth-brand"><img src="/waffarha-logo.png" alt="Waffarha" /><span>Nexus intelligence</span></div><section className="nexus-auth-card nexus-continuation-card" aria-live="polite"><span className="nexus-auth-kicker">WAFFARHA NEXUS</span><h1>{statusCopy.title}</h1><p className="nexus-auth-body">{statusCopy.body}</p>{state === "ready" && <button className="nexus-auth-submit" data-testid="auth-continue-button" type="button" onClick={continueAction}>Continue</button>}{state === "loading" && <p className="nexus-auth-hint">Opening the secure account flow…</p>}{state === "invalid" && <a className="nexus-auth-continue-link" href="/">Return to sign in</a>}<p className="nexus-auth-footer">This secure link is single-use. If you did not request it, you can safely close this page.</p></section></main></div>;
}
